import React, { useState } from 'react';
import axiosInstance from '../utils/axios-instance';
import { toast } from 'sonner';


const TestImage = () => {
  const [imageBase64, setImageBase64] = useState(null);
  const [description, setDescription] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onloadend = async () => {
      const base64String = reader.result;
      console.log('Base64 Image:', base64String);
      setImageBase64(base64String);
      await sendToApi(base64String);
    };
    reader.readAsDataURL(file);
  };

  const sendToApi = async (base64Image) => {
    const dataToSend = {
      prompt: 'describe this',
      image: base64Image,
    };

       try {
      const res = await axiosInstance.post('/chat/readimage', dataToSend);
      if (res.status === 200) {
        // toast.success(res.data.message);
         setDescription(res.data.message || 'No description returned.');
      } else {
        toast.error(res.data.message);
      }
    } catch (error) {
      toast.error(error.response.data.message);
    } finally {
      setLoading(false);
    }

  };

  return (
    <div className="p-4 border rounded max-w-md mx-auto">
      <h2 className="text-lg font-semibold mb-2">Upload an Image</h2>
      <input type="file" accept="image/*" onChange={handleFileChange} />
      {loading && <p className="mt-2 text-blue-500">Processing...</p>}
      {description && (
        <div className="mt-4 p-2 border rounded bg-gray-100">
          <strong>Description:</strong>
          <p>{description}</p>
        </div>
      )}
    </div>
  );
};

export default TestImage;
